import { render, staticRenderFns } from "./OwnProfile.vue?vue&type=template&id=7818dca1&scoped=true"
import script from "./OwnProfile.vue?vue&type=script&lang=js"
export * from "./OwnProfile.vue?vue&type=script&lang=js"
import style0 from "./OwnProfile.vue?vue&type=style&index=0&id=7818dca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818dca1",
  null
  
)

export default component.exports